module.exports = __webpack_public_path__ + "img/heart_11.cfaa1575.png";